import './Styles/__styles.css';
import { Stack, styled, Typography } from '@mui/material';
import React from 'react';

const StyledInputHeading = styled(Typography)(({ theme }) => ({
  fontSize: '.625rem',
  fontFamily: 'Aspekta !important',
  color: ' #7b8694',
  fontWeight: 700,
  lineHeight: '124%',
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
}));

interface VegaFormInputFieldPropsV2 {
  label: string;
  children: React.ReactNode;
  endAdornment?: React.ReactNode;
}

function VegaFormInputFieldV2({
  label,
  children,
  endAdornment,
}: VegaFormInputFieldPropsV2) {
  return (
    <Stack spacing={1}>
      <Stack
        direction={'row'}
        spacing={1}
        justifyContent="space-between"
        alignItems={'center'}
        maxHeight="0.75rem"
      >
        <StyledInputHeading>{label}</StyledInputHeading> {endAdornment}
      </Stack>
      {children}
    </Stack>
  );
}

export default VegaFormInputFieldV2;
